/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelLpisIntersect } from './parcelLpisIntersect.model';


export interface ParcelBarterEntity { 
    barteredFurtherRent?: boolean;
    cislNazev?: string;
    concernedUserIds?: Array<number>;
    drupozKod?: number;
    drupozNazev?: string;
    endDate?: string;
    geometry?: string;
    id?: number;
    isDefunct?: boolean;
    isLastVersion?: boolean;
    isOnSubcontract?: boolean;
    isOnValidOrProposalBarter?: boolean;
    isRentedAndFurtherRentPossible?: boolean;
    isWholeOwnedByConcerned?: boolean;
    katuzeKod?: number;
    katuzeNazev?: string;
    krajNazev?: string;
    lv?: number;
    obecNazev?: string;
    okresNazev?: string;
    parId?: number;
    parType?: string;
    parcelLpisIntersect?: ParcelLpisIntersect;
    parcis?: string;
    parcisDil?: number;
    parcisKmen?: number;
    parcisPod?: number;
    pronajataVymera?: number;
    prumernaCena?: number;
    rentedByConcerned?: boolean;
    rentedByConcernedFurtherRent?: boolean;
    startDate?: string;
    userIds?: Array<number>;
    vymera?: number;
    withoutAnyValidVersion?: boolean;
}

